export default __webpack_public_path__ + "static/media/PRS_logo.41949583.png";